# Link Preview

A rich preview card for URLs with title, description, and thumbnail.

## Install

```bash
npx aiapp-ui add link-preview
```

## Usage

```tsx
import { LinkPreview } from "@/components/aiapp-ui/link-preview";

<LinkPreview
  url="https://example.com/article"
  title="Understanding MCP Apps"
  description="A deep dive into the Model Context Protocol's app extension and how it enables rich UI in AI conversations."
  image="/og-image.jpg"
  domain="example.com"
/>;
```

**Role**: Information. For displaying rich link metadata inline in the conversation. See [Design Guidelines](/docs/design-guidelines) for how component roles work.

## Props

| Prop          | Type                    | Description                 |
| ------------- | ----------------------- | --------------------------- |
| `url`         | `string`                | The target URL              |
| `title`       | `string`                | Page title                  |
| `description` | `string?`               | Page description or excerpt |
| `image`       | `string?`               | Thumbnail or OG image URL   |
| `domain`      | `string?`               | Display domain              |
| `favicon`     | `string?`               | Favicon URL                 |
| `onNavigate`  | `(url: string) => void` | Custom navigation handler   |

## Behavior

- Clicking the card navigates to the URL (or calls `onNavigate` if provided)
- Images load lazily and display a placeholder on error
- The card truncates long descriptions to 2 lines

## Accessibility

- The entire card is a single interactive element with proper link semantics
- Image has an empty `alt` (decorative) since the title provides the label
- Focus ring visible on keyboard navigation
